const CLASSIFICATION_POLL_INTERVAL_MS = 3000

const isPending = (row: unknown): boolean => {
  if (typeof row !== 'object' || row === null) return false
  const classification = (row as { classification?: unknown }).classification
  if (typeof classification !== 'object' || classification === null) return false
  return (classification as { status?: unknown }).status === 'pending'
}

/**
 * Use as `refetchInterval: (query) => classificationRefetchInterval(query.state.data)` on any
 * useQuery whose response carries `classification.status`. Polls every 3s while any row is
 * `pending`, then stops once everything resolves. Works for both single-document and list shapes.
 */
export const classificationRefetchInterval = (data: unknown): number | false => {
  if (data == null) return false
  const rows = Array.isArray(data) ? data : [data]
  return rows.some(isPending) ? CLASSIFICATION_POLL_INTERVAL_MS : false
}
